export default "/images/vendor/flag-icon-css/flags/1x1/me.svg?4c8b84af010134d56b90d1ce18ad9e6b";